import React from 'react';
import stores from '../stores';

//debug purposes
// @ts-ignore
window.__stores = stores;

export const storesContext = React.createContext(stores);
